import React, {useState, useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';
import bird from '../../assets/icon-check-white.svg';
import clipboard from '../../assets/clipboard.svg';
import types from '../../types';
import {regTypes as R} from '../../constants/regTypes';
import styles from './styles.module.scss';

const LabelStageNames = ({
                           regType,
                           desktopCompletedStages = [],
                           prevCompletedStepSignTrue,
                           getSpecificStep,
                         }) => {
  const ref = useRef();
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  useEffect(() => {
    const checkIfClickedOutside = e => {
      if (showMobileMenu && ref.current && !ref.current.contains(e.target)) {
        setShowMobileMenu(false)
      }
    }
    document.addEventListener("mousedown", checkIfClickedOutside)

    return () => {
      document.removeEventListener("mousedown", checkIfClickedOutside)
    }
  }, [showMobileMenu]);

  const handleGoToSpecificStep = (stepID) => {
    Promise.resolve()
      .then(() => {
        getSpecificStep(stepID);
      })
      .then(() => {
        prevCompletedStepSignTrue();
      })
      .then(() => {
        setShowMobileMenu(false);
      })
  };
  const completedStagesWithoutFirst = desktopCompletedStages.filter(item => item.stepID !== 1);

  return (completedStagesWithoutFirst.length === 0 || regType !== R.ALL)
    ? null
    : (
      <div className={styles.stageNamesContainer}>
        <img
          src={clipboard}
          alt="clipboard"
          className={styles.showHideMenuIcon}
          onClick={() => {
            setShowMobileMenu(!showMobileMenu)
          }}
        />
        <div
          ref={ref}
          className={showMobileMenu ? styles.showStagesList : styles.hideStagesList}
        >
          <div className={styles.stagesTitle}>
            <FormattedMessage
              id="common.stage.completed.title"
              defaultMessage="So far you completed"
            />
          </div>
          {completedStagesWithoutFirst.map((item, ind) => (
            <div className={styles.stageName} key={ind}>
              <div className={styles.bird}>
                <img src={bird} alt="bird"/>
              </div>
              <div
                className={styles.label}
                onClick={() => {
                  handleGoToSpecificStep(item.stepID)
                }}
              >
                <FormattedMessage id={item.label}/>
              </div>
            </div>
          ))}</div>
      </div>
    )
};

LabelStageNames.propTypes = {
  ...types.router,
  regType: PropTypes.string,
  desktopCompletedStages: PropTypes.array,
};

export default LabelStageNames;
